export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
export const SET_TOTAL_ECHEANCES_BEFORE_NOW = 'SET_TOTAL_ECHEANCES_BEFORE_NOW';
export const SET_DISPLAY_ECHECHEANCES_ANT = 'SET_DISPLAY_ECHECHEANCES_ANT';
export const SET_DATES_ECHEANCES_SAVE = 'SET_DATES_ECHEANCES_SAVE';
